import { Component, Input, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { LogPuaService } from 'src/app/core/providers/services/log-pua/log-pua.service';
import { take } from 'rxjs/operators';
import { Numbers } from 'src/app/utils/constants';

@Component({
  selector: 'app-step-thanks',
  templateUrl: './steps-thanks.component.html',
  styleUrls: ['./steps-thanks.component.scss']
})
export class StepsThanksComponent implements OnInit, OnDestroy {

  /**
   * @description Es el paso
   */
  @Input() STEP: BehaviorSubject<any>;
  @Input() SUCCESS: boolean;
  @Input() IS_TPV: boolean;
  @Input() IS_PAY: boolean;
  @Output() CLOSE_COMP: EventEmitter<any> = new EventEmitter();

  currentStep = 0;
  rute = '/';
  tokenURL: any = '';

  private finish = new Subject();

  //#region Constructor
  /**
   * @ignore
   */
  constructor(
    private router: Router,
    private gtmService: GoogleTagManagerService,
    private logPuaService: LogPuaService,
    private activatedRoute: ActivatedRoute
  ) {
    this.router = router;
    this.gtmService = gtmService;
    this.logPuaService = logPuaService;
    this.activatedRoute = activatedRoute;
    this.activatedRoute.queryParams.subscribe((params: any) => {
      if (params.token !== undefined) {
        this.tokenURL = params.token;
      } else {
        this.tokenURL = '';
      }
      this.getPresuInfo(params);
    });
  }
  public redsysData: any;
  public dateDec: any;
  public hourDec: any;
  public email: any;
  public price: any;
  public parametters = false;

  /**
   * @ignore
   */
  ngOnInit(): void {
    const auxLink: string = location.pathname;
    this.rute = auxLink;

    if (!this.IS_PAY || this.IS_PAY === undefined) {
      this.initMessage();
    }
  }
  /**
   * @ignore
   */
  ngOnDestroy(): void {
    this.finish.next(true);
  }
  /**
   * obtener datos de Redsys
   * @param params parametros
   */
  getPresuInfo(params: any): void {
    if (params.Ds_MerchantParameters) {
      this.parametters = true;
      const merchantParams: any = params.Ds_MerchantParameters;
      const encryptedData: string = atob(merchantParams);
      this.redsysData = JSON.parse(encryptedData);
      this.dateDec = decodeURIComponent(this.redsysData.Ds_Date);
      this.hourDec = decodeURIComponent(this.redsysData.Ds_Hour);
      const numeroComoNumero = parseInt(this.redsysData.Ds_Amount, Numbers.number10);
      this.price = (numeroComoNumero / Numbers.number100).toFixed(Numbers.number2);
    }
  }

  /**
   * @description Mostrar mensaje de éxito/error y log
   */

  initMessage(): void {
    const productLayer: any = JSON.parse(localStorage.getItem('layer2'));
    this.email = localStorage.getItem('email');
    const idPresu: any = productLayer.id;
    let mensaje = 'INFO: Presupuesto ' + idPresu;

    if (this.SUCCESS) {
      // this.logService.traceError('INFO: Presupuesto ' + idPresu + ' - Mensaje de éxito ');
      mensaje = mensaje + ' - Mensaje de éxito';
    } else {
      // this.logService.traceError('INFO: Presupuesto ' + idPresu + ' - Mensaje de error ');
      mensaje = mensaje + ' - Mensaje de error';
    }

    this.logPuaService.postLogs({ data: mensaje }, mensaje).pipe(take(1)).subscribe();

    localStorage.removeItem('budget');
    localStorage.removeItem('email');
    localStorage.removeItem('pay');
    this.datalayer();
  }

  /**
   * @description Función para ir al inicio del formulario
   */
  navigateHome(): void {
    localStorage.removeItem('stepThanks');
    const urlL: string = this.router.url;
    const urlLToken: any = (this.tokenURL === '') ? urlL : urlL + '?token=' + this.tokenURL;
    if (!this.IS_TPV) {
      // window.location.href = urlL;
      window.location.href = urlLToken;
    } else {
      // this.router.navigate([this.rute]);
      if (this.tokenURL === '') {
        this.router.navigate([this.rute]);
      } else {
        this.router.navigate([this.rute], { queryParams: { token: this.tokenURL }});
      }
      this.CLOSE_COMP.emit(true);
    }
  }

  /**
   * @description Función para reiniciar el formulario
   */
  resetForm(): void {
    localStorage.removeItem('stepThanks');
    localStorage.setItem('resetForm', 'true');
    const urlL: any = this.router.url;
    const urlLToken: any = (this.tokenURL === '') ? urlL : urlL + '?token=' + this.tokenURL;
    this.CLOSE_COMP.emit(true);
    // window.location.href = urlL;
    window.location.href = urlLToken;
  }

  /**
   * @description asignar evento analítica
   */
  datalayer(): void {
    const datalayerD: any = {
      ategoria_seguro : 'viajes',
      event : 'ev_confirmation',
      event_action : 'Particular',
      event_category : 'contratacion',
      event_label : 'gestion_de_polizas',
      step : 'confirmacion',
      ecommerce : {
        transaction_id : this.redsysData.Ds_Order,
        value : this.price,
        currency : 'EUR'
      },
      detail : undefined
    };
    localStorage.removeItem('layer1');
    localStorage.removeItem('layer2');
    localStorage.removeItem('next-step3');
    this.gtmService.pushTag(datalayerD);
  }
}
